import * as z from 'zod/mini';
import { defineFormInput } from './defineFormInput.js';
/**
 * Schema for single-select form option.
 */
export const SingleSelectInputOption = z.object({
    label: z.string(),
});
export const SingleSelectInput = defineFormInput({
    type: 'SINGLE_SELECT',
    input: {
        question: z.string().check(z.describe(`Question to display to the user. Ask about a single thing.`)),
        help: z
            .optional(z.string())
            .check(z.describe('Help text to display to the user. Use it when you need to provide more context about the question, explain the reason or provide explanation for medical terms.')),
        options: z.array(SingleSelectInputOption),
    },
    description: `Ask the user to select one option from a list.`,
    value: {
        option: z.int32(),
        label: z.string(),
    },
});
//# sourceMappingURL=SingleSelectInput.js.map